<template>
  <div>
    <navbar></navbar>
    <gd-aside></gd-aside>
    <!-- Popup test parseur -->
    <gd-modal
      :class="{ 'open-modal' : testModalOpen }"
      :title="'Tester une configuration'"
      @closeModal="closeTestModal">
      <slot>
        <div>
          <label for="currentPage">Numéro de page à tester</label>
          <input id="currentPage"
                 type="number"
                 v-model.number="currentPageTest"
                 placeholder="Spécifier un numéro de page"
                 @change="launchTest(currentFile)"/>
        </div>
        <i class="loader" v-if="loadingTest"></i>
        <div class="gd-small-padding-layout" v-else-if="currentTestConf && !testResults">
          <span class="gd-label">Type : </span>
          {{ currentTestConf.name }} ({{ currentTestConf.id }})
          <br>
          <span class="gd-label">Fichier de test :</span>
          <div class="gd-input-file">
            <label for="testFile">Sélectionnez un fichier</label>
            <input
              type="file"
              id="testFile"
              accept="application/pdf"
              @change="launchTest($event.target.files)">
          </div>
        </div>
        <div class="gd-small-padding-layout" v-if="testResults">
          <button class="gd-default-btn"
                  @click="updateTestFile()">Changer de fichier de test</button>
          <div class="gd-label gd-text-center">
            Résultats des informations détectées sur le fichier de test
          </div>
          <div v-for="(metadataObject, index) in testResults"
               :key="`metadataResult${index}`">
            <div class="gd-m-b-10" v-for="(item, key) in metadataObject" :key="key">
              <div class="gd-circle"
                   :class="[{ 'gd-bckg-green' : item.length }, 'gd-bckg-red']"></div>
              <span class="gd-label gd-lowercase">{{ key }} :</span>
              <span v-if="item.length">{{ item }}</span>
              <span v-else class="gd-color-red">Pas de résultat</span>
            </div>
          </div>
        </div>
      </slot>
    </gd-modal>

    <!-- Popup visualisation JSON -->
    <gd-modal
      :class="{ 'open-modal' : jsonModalOpen }"
      :title="`Configuration : ${currentJsonConf.name}`"
      @closeModal="closeJsonModal"
      v-if="currentJsonConf">
      <slot>
        <div class="gd-layout-pre">{{ currentJsonConf }}</div>
      </slot>
    </gd-modal>

    <!-- Popup dupliquer configuration -->
    <modal-duplicate
      :class="{ 'open-modal' : confDuplicateOpen }"
      v-if="currentConfDuplicate"
      :configuration="currentConfDuplicate"
      @closeModal="closeConfDuplicate"></modal-duplicate>

    <!-- Popup uploader la configuration sur DeskRH -->
    <modal-uploader
      :class="{ 'open-modal' : confUploadOpen }"
      v-if="currentConfUpload"
      :configuration="currentConfUpload"
      @closeModal="closeUploaderConfiguration"></modal-uploader>

    <!-- Contenu de la page -->
    <main class="gd-main gd-bckg-very-light-grey">
      <div class="main-layout">
        <h1>Liste des configurations du parseur</h1>
        <div class="gd-vertical-small-padding-layout">
          <router-link :to="{ name: 'ladCreate', params: {file: currentFile} }"
                       class="gd-default-btn">
            <IconPlus class="gd-default-btn__icon gd-m-r-5"></IconPlus>
            Ajouter une configuration
          </router-link>
        </div>
        <div class="gd-vertical-small-padding-layout">
          <span class="gd-label gd-m-r-5">Rechercher par type de fichier :</span>
          <select
            class="gd-input-text" id="searchByType">
            <option value="" selected disabled="">-- Sélectionnez un type --</option>
            <option
              :value="type.id"
              v-for="type in fileTypes"
              :key="`searchOption${type.id}`">
              {{ type.description }}
            </option>
          </select>
          <span class="gd-m-h-5">
            <button id="searchdriverName" class="gd-rounded-btn" @click="search()">
              <IconResearch class="gd-rounded-btn__icon"></IconResearch>
            </button>
            <button
              v-if="onSearch"
              @click="resetSearch()"
              class="gd-rounded-btn gd-rounded-btn--small">
              <IconClose class="gd-rounded-btn__icon"></IconClose>
            </button>
          </span>
        </div>
        <div v-if="!parseurs.length" class="gd-vertical-medium-padding-layout">
          Pas encore de configuration enregistrée
        </div>
        <i class="loader" v-if="loadingParseurs"></i>
        <div v-else-if="parseurs.length">
          <div class="gd-vertical-small-padding-layout">
            <ul class="gd-log-list">
              <li
                v-for="(parseur, index) in parseurs"
                v-if="findParseurIndex(parseur.fileType) > -1"
                :key="`parseur${parseur.fileType}`"
                class="gd-log-list__item has-double-separator"
                @click="functionCollapse(index)">
                <div class="gd-ultra-bold gd-ultra-big-typo">
                  ID du type de fichier : {{ parseur.fileType }}
                </div>

                <div v-if="parseur.configurations.length === 1">
                  1 configuration liée à ce type de fichier
                </div>
                <div v-else>
                  {{parseur.configurations.length}} configurations liées à ce type de fichier
                </div>
                <div  @click.stop=""
                      v-show="listConfigShow[index]"
                      class="gd-vertical-small-padding-layout">
                  <ul class="gd-log-list">
                    <li
                      v-for="conf in parseur.configurations"
                      :key="`conf${conf.id}`"
                      class="gd-log-list__item gd-log-list__conf has-separator">
                      <div class="gd-split-table-layout">
                        <div class="gd-split-table-layout__part">
                          <div class="gd-ultra-bold
                           gd-ultra-big-typo gd-vertical-small-padding-layout">
                            {{ conf.name }}
                          </div>
                        </div>
                        <div class="gd-split-table-layout__part">
                          <button
                            class="gd-default-btn
                        gd-default-btn--small
                        gd-align-middle"
                            @click="testParseur(parseur.fileType, conf.id)">
                            <IconValid class="gd-default-btn__icon gd-m-r-5"></IconValid>
                            <span class="gd-default-btn__text">Tester</span>
                          </button>
                          <button
                            class="gd-default-btn
                        gd-default-btn--small
                        gd-align-middle"
                            @click="viewJson(parseur.fileType, conf.id)">
                            <IconVisualisation class="gd-default-btn__icon gd-m-r-5">
                            </IconVisualisation>
                            <span class="gd-default-btn__text">Visualiser JSON</span>
                          </button>
                          <button
                            class="gd-default-btn
                        gd-default-btn--small
                        gd-align-middle"
                            @click="duplicateConfiguration(parseur.fileType, conf)">
                            <IconCopy class="gd-default-btn__icon gd-m-r-5"></IconCopy>
                            <span class="gd-default-btn__text">Dupliquer</span>
                          </button>
                          <button
                            class="gd-default-btn
                        gd-default-btn--small
                        gd-align-middle"
                            @click="saveConfigurationOnDesKRH(parseur.fileType, conf)">
                            <IconCopy class="gd-default-btn__icon gd-m-r-5"></IconCopy>
                            <span class="gd-default-btn__text">Envoyer sur DeskRH</span>
                          </button>
                          <button
                            class="gd-default-btn
                        gd-default-btn--small
                        gd-align-middle"
                            @click="updateConfiguration(parseur.fileType, conf)">
                            <IconUpdate class="gd-default-btn__icon gd-m-r-5"></IconUpdate>
                            <span class="gd-default-btn__text">Mettre à jour</span>
                          </button>
                          <button
                            class="gd-default-btn
                        gd-default-btn--small
                        gd-align-middle"
                            @click="deleteConfig(parseur.fileType, conf.id)">
                            <IconDelete class="gd-default-btn__icon gd-m-r-5"></IconDelete>
                            <span class="gd-default-btn__text">Supprimer</span>
                          </button>
                        </div>
                      </div>
                      <div>
                        Id de la configuration : {{ conf.id }}
                      </div>
                      <div>Métadonnées concernées :</div>
                      <div class="gd-vertical-small-padding-layout">
                  <span
                    :key="`metadata${index}`"
                    class="gd-tag gd-tag--dark-grey gd-m-b-5 gd-m-r-5"
                    v-for="(metadata, index) in
                    parseur.configurations[findConfigurationIndex(parseur.fileType, conf.id)]
                      .metadatas">
                    {{ metadata.friendlyName }}
                  </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import IconUpdate from '@/assets/svg/icon-update.svg';

import Aside from '@/components/Aside';
import Navbar from '@/components/Navbar';
import GdModal from '@/components/Modal';
import IconClose from '@/assets/svg/icon-close.svg';
import IconCopy from '@/assets/svg/icon-copy.svg';
import IconDelete from '@/assets/svg/icon-delete.svg';
import IconPlus from '@/assets/svg/icon-plus.svg';
import IconResearch from '@/assets/svg/icon-research.svg';
import IconValid from '@/assets/svg/icon-valid.svg';
import IconVisualisation from '@/assets/svg/icon-visualisation.svg';
import DuplicateConfiguration from '@/components/DuplicateConfiguration';
import UploadConfiguration from '@/components/SaveConfigurationToDeskRH';

export default {
  name: 'lad-listing',
  props: ['file'],
  components: {
    IconClose,
    IconCopy,
    IconDelete,
    IconUpdate,
    IconPlus,
    IconResearch,
    IconValid,
    IconVisualisation,
    'gd-aside': Aside,
    'gd-modal': GdModal,
    'modal-duplicate': DuplicateConfiguration,
    'modal-uploader': UploadConfiguration,
    Navbar,
  },

  data() {
    return {
      onSearch: false,
      parseurs: [],
      loadingTest: false,
      testModalOpen: false,
      loadingParseurs: false,
      currentTestConf: undefined,
      currentFileTest: undefined,
      currentPageTest: 1,
      testResults: undefined,
      jsonModalOpen: false,
      confDuplicateOpen: false,
      currentJsonConf: undefined,
      currentConfDuplicate: undefined,
      fileTypes: [],
      configurations: [], // {id, name, metadatas}
      test: [],
      listConfigShow: [],
      currentFile: undefined,
      confUploadOpen: false,
      currentConfUpload: undefined,
    };
  },

  methods: {
    ...mapActions({
      getApiParseurs: 'lad/getParseurs',
      apiTestMetadatas: 'lad/testMetadatasFileType',
      apiDeleteConfig: 'lad/deleteConfig',
      apiGetFileTypes: 'lad/getFileTypes',
    }),
    toggleItem(par) {
      // eslint-disable-next-line no-param-reassign
      par.isCollapse = !par.isCollapse;
      console.log(` t => ${par.isCollapse}`);
    },
    toto(par) {
      return par.isCollapse;
    },
    updateConfiguration(fileType, conf) {
      this.$router.push({ name: 'ladUpdate', params: { fileType, conf, file: this.currentFile } });
    },
    duplicateConfiguration(fileType, conf) {
      this.confDuplicateOpen = true;
      this.currentConfDuplicate = { fileType, conf };
    },
    saveConfigurationOnDesKRH(fileType, conf) {
    // open dialog
      this.confUploadOpen = true;
      this.currentConfUpload = { fileType, conf };
    },
    closeUploaderConfiguration() {
      this.confUploadOpen = false;
      this.currentConfUpload = undefined;
    },
    closeConfDuplicate() {
      this.confDuplicateOpen = false;
      this.currentConfDuplicate = undefined;
      this.resetSearch();
    },

    findParseurIndex(type) {
      return this.parseurs.findIndex(elmt => elmt.fileType === type);
    },
    findConfigurationIndex(type, confId) {
      const toto = this.findParseurIndex(type);

      return this.parseurs[toto]
        .configurations
        .findIndex(elmt => elmt.id === confId);
    },
    findConfiguration(type, confId) {
      return this.parseurs[this.findParseurIndex(type)]
        .configurations[this.findConfigurationIndex(type, confId)];
    },
    initCollapseItems() {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const i in this.parseurs) {
        this.test[i] = false;
        this.parseurs[i].isCollapse = false;
        this.listConfigShow[i] = false;
        // this.parseurs[i].collapse = false;
        // this.test[this.parseurs[i].fileType] = false;
      }
    },
    search() {
      this.onSearch = true;
      const value = document.getElementById('searchByType').value;
      this.loadingParseurs = true;
      this.getApiParseurs({ fileType: value })
        .then((data) => {
          this.parseurs = data.metadatas;
          this.initCollapseItems();
          this.loadingParseurs = false;
        });
    },

    resetSearch() {
      document.getElementById('searchByType').options[0].selected = true;
      this.onSearch = false;
      this.loadingParseurs = true;
      this.getApiParseurs()
        .then((data) => {
          this.parseurs = data.metadatas;
          this.initCollapseItems();
          this.loadingParseurs = false;
        });
    },

    testParseur(type, confId) {
      const configuration = this.findConfiguration(type, confId);
      if (configuration !== undefined) {
        this.currentTestConf = configuration;
      }
      this.testModalOpen = true;
      this.currentPageTest = 1;
      if (this.currentFile !== undefined) {
        this.loadingTest = true;
        this.launchTest(this.currentFile);
      }
    },
    updateTestFile() {
      this.currentFile = undefined;
      this.testResults = undefined;
      this.jsonModalOpen = false;
      this.jsonModalOpen = true;
    },
    viewJson(type, confId) {
      const configuration = this.findConfiguration(type, confId);
      console.log(configuration);
      if (configuration !== undefined) {
        this.currentJsonConf = configuration;
      }
      this.jsonModalOpen = true;
    },

    closeJsonModal() {
      this.currentJsonConf = undefined;
      this.jsonModalOpen = false;
    },
    closeTestModal() {
      this.currentTestConf = undefined;
      this.testModalOpen = false;
      this.testResults = undefined;
    },

    launchTest(file) {
      if (file !== undefined) {
        this.currentFile = file;
        this.loadingTest = true;
        const formData = new FormData();
        formData.append('pdf', file[0]);

        this.currentTestConf.metadatas.map((metadata) => {
          // eslint-disable-next-line no-param-reassign
          metadata.pageNumber = this.currentPageTest;
          return metadata;
        });
        console.log('JSON stringified');
        console.log(JSON.stringify(this.currentTestConf.metadatas));

        formData.append('metadatas', JSON.stringify(this.currentTestConf.metadatas));
        this.apiTestMetadatas(formData)
          .then((data) => {
            this.testResults = data.data.data.result;
            this.loadingTest = false;
          })
          .catch(error => console.log(error));
      }
    },

    deleteConfig(type, confId) {
      this.loadingParseurs = true;
      this.apiDeleteConfig([type, confId])
        .then(() => {
          this.getApiParseurs()
            .then((data) => {
              this.parseurs = data.metadatas;
              this.initCollapseItems();
              this.loadingParseurs = false;
            });
        });
    },

    functionCollapse(index) {
      const newList = Object.assign([], this.listConfigShow);
      newList[index] = !this.listConfigShow[index];
      this.listConfigShow = newList;
    },
  },

  mounted() {
    if (this.file) {
      this.currentFile = this.file;
    }

    this.loadingParseurs = true;
    this.apiGetFileTypes()
      .then((data) => {
        this.fileTypes = data.data.data;
        this.fileTypes.sort((a, b) => {
          if (a.description < b.description) return -1;
          if (a.description > b.description) return 1;
          return 0;
        });
      });
    this.getApiParseurs()
      .then((data) => {
        this.parseurs = data.metadatas;
        this.initCollapseItems();
        this.loadingParseurs = false;
      });
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/LADListing.vue